// 依照 API /air-transfer/provider/policy 回傳的資料為主
// export const ORDER_MIN_TIME_AFTER_DAYS = 3
// export const ORDER_MIN_CANCELLATION_DAYS = 4

export const EXTRA_STOPS_LIMIT = 1;
export const ADDON_DEFAULT_MAX_VALUE = 4;
export const ADDON_DEFAULT_MIN_VALUE = 0;
export const MAX_PASSENGER_COUNT = 6;

export const SERVICE_ADDON_CHILD_SAFETY_SEAT = 'child_safety_seat';
export const SERVICE_ADDON_BOOSTER_SEAT = 'booster_seat';
export const SERVICE_ADDON_NAME_SIGN = 'name_sign';
export const SERVICE_ADDON_EXTRA_STOP = 'extra_stop';
export const SERVICE_ADDON_RED_EYE_FEE = 'redeye_fee';
export const ORDER_TYPE_ARRIVAL = 'arrival';
export const ORDER_TYPE_DEPARTURE = 'departure';

/**
 * ACTIONS
 * full - 全額退款
 * part-refund - 部分退款
 * partial - 部分退款
 * none - 不退款
 */
export const ORDER_REFUND_TYPE_FULL = 'full';
/**
 * @deprecated
 */
export const ORDER_REFUND_TYPE_PART_REFUND = 'part-refund';
export const ORDER_REFUND_TYPE_PARTIAL = 'partial';
export const ORDER_REFUND_TYPE_NONE = 'none';

/**
 * STATES
 * if 已經取消
 * refunded - 全額退款
 * part_refunded - 部分退款
 * paid - 已付款 (不退)
 */
export const ORDER_REFUND_TYPE_REFUNDED = 'refunded';
export const ORDER_REFUND_TYPE_PART_REFUNDED = 'part_refunded';
export const ORDER_REFUND_TYPE_PAID = 'paid';
export const ORDER_REFUND_TYPE_FAILED = 'failed';

/**
 *  行銷專區
 */
export const META_TITLE = 'UGO 機場接送';
export const META_DESCRIPTION =
  '雙北接送桃園機場只要 798 元起，業界最低價。提供安全、舒適優質的機場接送服務，24 小時前預約保證派車，搭配全天候專人客服，讓您不管是出差出國返鄉都安心！';
// 網站 Header 的行銷文字 太長會擠出第二行
export const MARKETING_BAR_TEXT =
  '4/30 - 5/5, 5/29 - 6/2 適逢勞動節及端午連假，訂單將加收 200 元服務費，其他時段不受影響。首購優惠現折 150 元，回程再享 88 折優惠，同時預約接送機好划算！';

// 首頁的 banner
export const MARKETING_BANNER_LINK = undefined;
export const MARKETING_BANNER = '/banner_go_0521.jpg';
export const MARKETING_BANNER_ALT = MARKETING_BAR_TEXT;
// banner 右下角的顏色自己摳
export const MARKETING_BANNER_BG = '#1c1d1a';

export const NO_COUPON_VEHICLE_TYPE_IDS = [
  '9900a0d8-5b0d-47de-a616-6c78cd63d3a3', // 舒適五人座
  '74028740-ccd5-47fd-9aac-ee1bd3155be2', // 舒適五人座 ⚠️升級 RAV /CC 或同級休旅車
  'cbd04b92-3f89-4675-a626-94dee6269115', // 舒適五人座 ⚠️升級 TESLA Model 3 或 Y
];

// 預約時的選擇車種卡片下方文字
// FIXME: 安琪拉說，這個字很醜醜，可以的話先不要用
export const MARKETING_EVENT_TEXT = '';
// 預約時的優惠活動標題
export const MARKETING_EVENT_TITLE = '車款建議';
// 預約時的優惠活動內容
export const MARKETING_EVENT_CONTENT = (
  <div>
    {`舒適五人座
      建議搭乘 3 人以下｜總行李數 3 件內｜28-30 吋行李 1 件以內
      適合個人差旅的第一首選

      進口五人座
      建議搭乘 3 人以下｜總行李數 3 件內｜28-30 吋行李 1 件以內
      適合追求行車質感及舒適度的你

      不指定九人座
      建議人數 3-6 人｜總行李數 6 件內｜28-30 吋行李可 2 件以上
      適合好友結伴、親子家庭等多人出遊

      指定賓士九人座
      建議人數 3-6 人｜總行李數 6 件內｜28-30 吋行李可 2 件以上
      適合攜帶大量行李的理想選擇

      豪華商務七人座
      建議人數 3-6 人｜總行李數 4 件內｜28-30 吋行李 2 件以內
      適合追求頂級舒適與豪華、商務禮賓需求`}
  </div>
);
